import { asyncCallback } from "../utils/analysis-async";
import { StepProcess } from "../interfaces/stepProcess";
import { DangerousExtensionDTO, DangerousExtensionLevelEnum, NodeData, ResultInfo } from "../models/shared.model";
import { StepResult } from "../models/step-result";

export class EmailHasAttachments extends StepProcess {
  process = async (data?: NodeData): Promise<any> => {
    let attachments = this.attachmentService.getAttachments();

    let res = false;
    let count = 0;
    if (attachments && attachments.length > 0) {
      res = true;
      count = attachments.length;
    }

    return asyncCallback<any>(async (resolve) => {
      resolve(new StepResult(res, `${count} ${this.translate.instant('attachment_flow.attachments_found')}`));
    });
  };
}

export class CheckExtensionDangerousLevel extends StepProcess {

  constructor(props) {
    super(props);

  }

  process = async (data?: NodeData, info?: ResultInfo): Promise<any> => {

    return asyncCallback<any>(async (resolve, reject) => {
      try {
        const dangerousExtensions: DangerousExtensionDTO[] = this.attachmentService.getDangerousFileExtensions();

        const fileExt = this.attachmentService.parseAttachmentExtension(data.attachment);

        let extension = dangerousExtensions.find(element => element.name === fileExt.toLowerCase());
        let result = "none";
        if (extension)
          result = DangerousExtensionLevelEnum[extension.level];
        let reasonLog = extension ? this.translate.instant('attachment_flow.dangerous_extension_found', {fileExt, result}) :
                this.translate.instant('attachment_flow.dangerous_extension_not_found', {fileExt})

        resolve(new StepResult(result, reasonLog, { ...info, attachmentLevel: extension?.level }));
      } catch (e) {
        console.log(this.translate.instant('attachment_flow.extension_check_error', {error: e}));
        reject(e);
      }
    });
  };
}

export class IsExtensionRelevantToContext extends StepProcess {

  constructor(props) {
    super(props);

  }

  process = async (data?: NodeData): Promise<any> => {
    return asyncCallback<any>(async resolve => {

      resolve(new StepResult(true, this.translate.instant('attachment_flow.not_implemented')));
    });
  };
}
